import { Item } from '../redux/api/types';

function findItemByUuid(items: Item[], uuid: string): Item | undefined {
  for (const item of items) {
    if (item.uuid === uuid) {
      // return the item if the uuid matches
      return item;
    }

    // recursively search the children if present
    if (item.customer_groups && item.customer_groups.length > 0) {
      const foundInCustomerGroups = findItemByUuid(item.customer_groups, uuid);
      if (foundInCustomerGroups) {
        // return the item if found in the children
        return foundInCustomerGroups;
      }
    }
  }

  // return undefined if no item is found
  return undefined;
}

export default findItemByUuid;
